import React from "react";

import styles from "./SupportHeader.module.css";

const SupportHeader = ({ categories }) => {
    return (
        <div className={styles.supportHeader} data-testid="support-header">
            {categories?.map((category) => (
                <a
                    key={category}
                    className={styles.supportCategoryTitle}
                    href={`#${category}`}
                >
                    {category}
                </a>
            ))}
        </div>
    );
};

export default SupportHeader;
